import React, { Component } from 'react'
import Header from '../Header'
import './XVIIIw.css'

class XVIIIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXVIIIw">
                    <p className="textXVIIIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XVIIIw